module.exports = __webpack_public_path__ + "static/earning-potential-f7454ac108744e11a2538b2c2eec6333.png";